import { Box } from '@mui/material';
import PrivacyComponent from './PrivacyComponent';

export default function Privacy() {
  return (
    <Box mt={['2.75rem', '2.75rem', '5.5625rem']}>
      <PrivacyComponent />
    </Box>
  );
}
